import { useQuery } from "@tanstack/react-query";
import { getCombinedStats, getCombinedUsers } from "./client";

/**
 * Hook to fetch combined stats across Hyperliquid and Orderly
 * @param {Object} params - Query parameters
 * @param {string} [params.from] - ISO-8601 start date
 * @param {string} [params.to] - ISO-8601 end date
 * @returns {Object} React Query result
 */
export function useCombinedStats({ from, to } = {}) {
  return useQuery({
    queryKey: ["combined", "stats", { from, to }],
    queryFn: () => getCombinedStats({ from, to }),
    staleTime: 30_000, // Cache for 30 seconds
    refetchInterval: 60_000, // Auto-refresh every 60 seconds
  });
}

/**
 * Hook to fetch combined per-user data across Hyperliquid and Orderly
 * @param {Object} params - Query parameters
 * @param {string} [params.from] - ISO-8601 start date
 * @param {string} [params.to] - ISO-8601 end date
 * @param {number} [params.page=1] - Page number
 * @param {number} [params.limit=20] - Items per page
 * @returns {Object} React Query result
 */
export function useCombinedUsers({ from, to, page = 1, limit = 20 } = {}) {
  return useQuery({
    queryKey: ["combined", "users", { from, to, page, limit }],
    queryFn: () => getCombinedUsers({ from, to, page, limit }),
    staleTime: 30_000,
    placeholderData: (previousData) => previousData,
  });
}
